import request from '../utils/request';
//搜索数据
export function toClassCenter(data) {
  return request({
    url: '/wap/class/toSearch.html',
    method: 'post',
    data
  })
}





